module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/check-a3770b11fe177cb82340bef611a25bfd.svg";